import React, { useEffect, useRef } from "react";
import { MapPinOff } from "lucide-react";
import { datadogRum } from "@datadog/browser-rum";
import { BaseAlert } from "./base/BaseAlert";

export type NeighborhoodMissingScreen =
  | "private-office-create"
  | "private-office-edit"
  | "private-office-review";

interface NeighborhoodMissingAlertProps {
  spaceId: string;
  spaceName: string;
  screen: NeighborhoodMissingScreen;
}

const loggedSpaceIds = new Set<string>();

export const NeighborhoodMissingAlert: React.FC<
  NeighborhoodMissingAlertProps
> = ({ spaceId, spaceName, screen }) => {
  const spaceNameRef = useRef(spaceName);
  const screenRef = useRef(screen);
  spaceNameRef.current = spaceName;
  screenRef.current = screen;

  useEffect(() => {
    const key = `${screenRef.current}:${spaceId}`;
    if (loggedSpaceIds.has(key)) {
      return;
    }
    loggedSpaceIds.add(key);
    datadogRum.addAction("space_without_neighborhood", {
      spaceId,
      spaceName: spaceNameRef.current,
      screen: screenRef.current,
      level: "warn",
    });
  }, [spaceId]);

  return (
    <BaseAlert
      type="warning"
      title="Bairro não cadastrado para este espaço"
      message="A análise estatística está indisponível. Solicite ao time de Dados o cadastro do bairro para habilitar."
      icon={<MapPinOff className="w-5 h-5" />}
      data-testid="neighborhood-missing-alert"
    />
  );
};
